import { render } from "./loading-data.vue?vue&type=template&id=56c45acb&scoped=true"
const script = {}

import "./loading-data.vue?vue&type=style&index=0&id=56c45acb&lang=scss&scoped=true"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c45acb"]])

export default __exports__